import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import ProtectedManagementCompanySectionRoute from './ProtectedManagementCompanySectionRoute';
import { PRIVATE_PATH, PERMISSION } from '../constants';
import FlexProfessionals from '../features/flex/workforce/FlexWorkforceScreen';
import FlexProfessionalDetails from '../features/flex/professionals/FlexProfessionalDetails';
import FlexProfessionalsCreate from '../features/flex/professionals/FlexProfessionalsCreate';
import FlexFacilitiesWrapper from '../features/flex/facilities/FlexFacilitiesWrapper';
import ManagementCompanySettings from '../features/flex/settings/ManagementCompanySettings';
import OnDemandStaffProfessionalDetails from '../features/on-demand-staff/professionals/OnDemandStaffProfessionalDetails';

const WORKFORCE_PATH_PERMISSIONS = [PERMISSION.WORKFORCE_VIEW, PERMISSION.WORKFORCE_SHIFTMED_VIEW];

const ManagementCompanyRoutes = ({ userData, activeFacility }) => (
	<Switch>
		<ProtectedManagementCompanySectionRoute
			exact
			path={PRIVATE_PATH.WORKFORCE_PAGE}
			key={`workforce-${activeFacility}`}
			component={FlexProfessionals}
			pathPermission={WORKFORCE_PATH_PERMISSIONS}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path={`${PRIVATE_PATH.WORKFORCE_PAGE}/:managementCompanyId/on-demand-staff/:caregiverId/credentials`}
			key={`on-demand-staff-professional-${activeFacility}`}
			component={OnDemandStaffProfessionalDetails}
			pathPermission={PERMISSION.WORKFORCE_SHIFTMED_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path="/private/workforce/:managementCompanyId/professionals/create"
			key={`add-professional-${activeFacility}`}
			component={FlexProfessionalsCreate}
			pathPermission={PERMISSION.PORTAL_ADD_FLEX_PROFESSIONAL}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path="/private/workforce/:managementCompanyId/professionals/:caregiverId"
			key={`employee-details-${activeFacility}`}
			component={FlexProfessionalDetails}
			pathPermission={PERMISSION.WORKFORCE_PROFESSIONAL_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path="/private/workforce/:managementCompanyId/facilities/:facilityId"
			key={`facility-screens-${activeFacility}`}
			component={FlexFacilitiesWrapper}
			pathPermission={PERMISSION.WORKFORCE_LOCATIONS_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			exact
			path={PRIVATE_PATH.COMPANY_SETTINGS}
			key={`settings-default-${activeFacility}`}
			component={ManagementCompanySettings}
			pathPermission={PERMISSION.SETTINGS_PAGE_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<ProtectedManagementCompanySectionRoute
			path={`${PRIVATE_PATH.COMPANY_SETTINGS}/:managementCompanyId`}
			key={`settings-${activeFacility}`}
			component={ManagementCompanySettings}
			pathPermission={PERMISSION.SETTINGS_PAGE_VIEW}
			globalManagementCompanyPermissions={userData.globalManagementCompanyPermissions}
		/>
		<Redirect to="/404" />
	</Switch>
);

export default ManagementCompanyRoutes;
